import { cn } from '@/core/utils/common'

import type { ReactNode } from 'react'

type Props = { name?: string | null; avatar: ReactNode; overlap?: boolean }

export default function DialogueHead({ name, avatar, overlap = false }: Props) {
  return (
    <div
      className={cn(
        'relative flex',
        overlap ? 'mb-1 h-5 items-start' : 'mb-2 h-10 items-center'
      )}
    >
      <span
        className={cn(
          'size-10 flex-none',
          overlap ? 'absolute top-0 left-0' : 'relative'
        )}
      >
        {avatar}
      </span>
      <b
        className={cn(
          'min-w-0 truncate text-c13 leading-5 font-semibold text-t2 over10:text-c14',
          overlap ? 'pl-12' : 'ml-2'
        )}
      >
        {name}
      </b>
    </div>
  )
}
